import {defaultModules, defaultStack, defaults} from '@pnotify/core';
import * as PNotifyMobile from '@pnotify/mobile';
import '@pnotify/core/dist/PNotify.css';
import '@pnotify/mobile/dist/PNotifyMobile.css';

defaultModules.set(PNotifyMobile, {});

defaultStack.dir1 = 'down';
defaultStack.dir2 = 'left';
defaultStack.firstpos1 = 25;
defaultStack.firstpos2 = 25;
defaultStack.modal = false;
defaultStack.maxOpen = Infinity;

defaults.delay = 3000;
